import React, { useCallback } from 'react';
import { Alert, Popover } from 'antd';
import { useBackupSkuRedistributionMutation } from './apiCalculationEdit';
import { Button, Row } from '@ydistri/ds';
import { useCalculationEdit } from './useCalculationEdit';
import { useAppDispatch } from '../../../store';
import { addToast } from '@ydistri/utils';
import { problemMessagesOf } from '../../Configuration/Validator/problemsLib';

interface EditRedistributionBackupInfoProps {
  calculationId: number;
}

const EditRedistributionBackupInfo: React.FC<EditRedistributionBackupInfoProps> = ({
  calculationId,
}) => {
  const dispatch = useAppDispatch();
  const { isBackedUp, isFetching, disabledTooltipMessage } = useCalculationEdit(calculationId);
  const [backupSkuRedistribution, { isLoading }] = useBackupSkuRedistributionMutation();

  const backupHandler = useCallback(() => {
    backupSkuRedistribution(calculationId)
      .unwrap()
      .then(() => {
        dispatch(addToast({ message: 'Calculation backed up' }));
      })
      .catch((error: unknown) => {
        dispatch(
          addToast({
            message: problemMessagesOf(error, 'An error occurred while backing up a calculation'),
            isError: true,
          }),
        );
      });
  }, [backupSkuRedistribution, calculationId, dispatch]);

  if (!isBackedUp) {
    return (
      <Alert
        message={
          <Row $gap="1rem" $alignItems="center" $justifyContent="space-between">
            Calculation is not backed up yet.
            <Popover content={disabledTooltipMessage}>
              <Button
                loading={isLoading}
                onClick={backupHandler}
                disabled={isLoading || isFetching || disabledTooltipMessage !== undefined}
              >
                Backup calculation
              </Button>
            </Popover>
          </Row>
        }
        type="warning"
        showIcon
      />
    );
  }
  return <>Wrong parameters.</>;
};

export default EditRedistributionBackupInfo;
